export default class RecommendedButtonBasic {
  constructor() {
    this.id = 'getRecommendedBrochureButton';
  }

  /**
   * 
   * @returns the HTML that represents the basic recommendation modal button.
   */
  getHtml() {
    return `<button id="${this.id}" data-qa="get-recommendations-button" class="btn btn--yellow btn--48-lg" data-get-reco-brochure>I'm Interested!</button>`;
  }

  /**
   * 
   * @returns the HTML button in the element with the corresponding id.
   */
  getNode() {
    return document.getElementById(this.id);
  }
}